export class ChangeOrderNonStandardOption {
    public id: number;
    public jobChangeOrderId: number;
    public nonStandardOptionName: string;
    public nonStandardOptionDescription: string;
    public financialOptionNumber: string;
    public action: string;
    public quantity: number;
    public unitPrice: number;
    public createdBy: string;
    public createdUtcDate: Date;
    public lastModifiedBy: string;
    public lastModifiedUtcDate: Date;
}